import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=2fd99e78&scoped=true&"
import script from "./Chips.vue?vue&type=script&lang=js&"
export * from "./Chips.vue?vue&type=script&lang=js&"
import style0 from "./Chips.vue?vue&type=style&index=0&id=2fd99e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd99e78",
  null
  
)

export default component.exports